import { initializeFaro, getWebInstrumentations } from '@grafana/faro-web-sdk';
import { getSessionCorrelationId } from './correlation';
import { APP_VERSION } from './appVersion';

export function initFaro() {
  const url = process.env.REACT_APP_FARO_URL;
  if (!url) {
    // ponytail: no collector configured — skip RUM (local/dev default)
    return null;
  }
  try {
    const correlationId = getSessionCorrelationId();
    return initializeFaro({
      url,
      app: {
        name: 'pegasus-ui',
        version: APP_VERSION,
        environment: process.env.NODE_ENV || 'development',
      },
      sessionTracking: {
        generateSessionId: () => correlationId,
      },
      instrumentations: [...getWebInstrumentations()],
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[faro] init failed', e);
    return null;
  }
}
